import React from 'react';
import { Box, Typography } from '@mui/material';
import { DefaultLayout } from '../../components/layout/default-layout';
import { useMetaTitle } from '../../hooks';
import { useFeatureToggles } from '../../feature-toggles';
import { TenantAddonConstants, useTenantAddons } from '../../components/tenant-addons';
import { CircularProgressCentered } from '../../components/circular-progress-centered';
import { PageNotFound } from '../../404';
import { useIsAllowed } from '../../authentication/use-is-allowed';
import { ResourceOperations, ResourceTypes } from '../../authentication/resources';
import { InterventionLadder } from './intervention-ladder/intervention-ladder';

export const managementInformationFeatureToggle = 'EnableLedelsesinformation';

const requiredTenantAddons = [TenantAddonConstants.Ledelsesinformation];
const managementInformationAccess = [{ resourceType: ResourceTypes.Report, resourceOperation: ResourceOperations.Read }];

function ManagementInformationContent() {
  useMetaTitle('Ledelsesinformation');

  return (
    <Box sx={{ px: 2, pt: 3, pb: 6 }}>
      <Typography variant="h1" sx={{ fontSize: '1.35rem' }}>
        Ledelsesinformation
      </Typography>
      <InterventionLadder />
    </Box>
  );
}

export function ManagementInformationPage() {
  const { isFeatureEnabled } = useFeatureToggles();
  const { isTenantAddonEnabled, tenantAddons } = useTenantAddons();
  const isAllowed = useIsAllowed(managementInformationAccess);

  if (tenantAddons === undefined) {
    return <CircularProgressCentered />;
  }

  if (!isFeatureEnabled(managementInformationFeatureToggle) || !isTenantAddonEnabled(requiredTenantAddons) || !isAllowed) {
    return <PageNotFound />;
  }

  return (
    <DefaultLayout>
      <ManagementInformationContent />
    </DefaultLayout>
  );
}
